import Node from '../../core/node/Node';

interface StackInfo {
	nodes:Node[];
	scroll:{ x:number, y:number };
}


class NodeStack {

	target:Node;
	private _stack:StackInfo[];

	constructor( target?:Node ) {
		this.target = target;
		this._stack = [];
	}

	stack( nodes:Node|Node[] ) {

		if( nodes instanceof Node ) nodes = [ nodes ];

		var current = {
			scroll: { x: window.scrollX, y:window.scrollY },
			nodes: this.target.children()
		}

		this._stack.push( current );
		this.target.empty();
		this.target.append( nodes );
		window.scrollTo( 0, 0 );
	}

	pop() {
		var info = this._stack.pop();

		this.target.empty();
		this.target.append( info.nodes );
		window.scrollTo( info.scroll.x, info.scroll.y );
	}

	first() {
		this._stack.splice(1);
		this.pop();
	}

	count() {
		return this._stack.length;
	}
}

export default NodeStack;
